import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from 'assets/images/logo-color.svg';
import { Container, Modal } from 'components/elements';
import ZCalendar from 'components/zCalendar';
import { MailOutlined, PhoneOutlined, CreditCardOutlined, AppleOutlined } from '@ant-design/icons';
import DonateForm from 'components/donateForm';
import {
  FooterWrapper,
  ContentGrid,
  InfoTitle,
  InfoDescription,
  ContactRow,
  ContactItem,
  DonationPanel,
  DonationButton,
  PaymentRow,
  PaymentIcons,
  PaymentChip,
  BottomBar,
  BottomContent,
  BrandLogo,
  LegalLinks,
} from './index.styled';

const Footer = () => {
  const [donateModalVisible, setDonateModalVisible] = useState(false);

  return (
    <FooterWrapper>
      <Modal
        open={donateModalVisible}
        onCancel={() => {
          setDonateModalVisible(false);
        }}
      >
        <DonateForm
          paypalEmail="admin@polgozar.org"
          stripePublishableKey={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ''}
          onFormSubmitted={() => setDonateModalVisible(false)}
          onApplePaySuccess={() => setDonateModalVisible(false)}
        />
      </Modal>

      <Container>
        <ContentGrid>
          <BrandLogo href="/" mobileShow={true}>
            <img src={Logo} alt="polgozar" />
          </BrandLogo>

          <section>
            <InfoTitle>Support our Organization</InfoTitle>
            <InfoDescription>
              Polgozār is an online Daremehr for meeting friends and sharing stories, scholarship, celebrations, and rituals, thus strengthening our Zoroastrian community and identity.
            </InfoDescription>

            <ContactRow>
              <ContactItem href="mailto:polgozar@gmail.com">
                <MailOutlined />
                <span>Contact us:</span>
                <strong>polgozar@gmail.com</strong>
              </ContactItem>

              <ContactItem href="tel:+19167922512">
                <PhoneOutlined />
                <span>Call us:</span>
                <strong>+1 916-792-2512</strong>
              </ContactItem>
            </ContactRow>
          </section>

          <ZCalendar />

          <DonationPanel>
            <DonationButton type="primary" onClick={() => setDonateModalVisible(true)}>
              Make a Donation
            </DonationButton>

            <PaymentRow>
              <span>We accept:</span>
              <PaymentIcons>
                <PaymentChip>
                  <CreditCardOutlined />
                </PaymentChip>
                <PaymentChip>
                  <AppleOutlined />
                </PaymentChip>
              </PaymentIcons>
            </PaymentRow>
          </DonationPanel>
        </ContentGrid>
      </Container>

      <BottomBar>
        <Container>
          <BottomContent>
            <BrandLogo href="/" mobileShow={false}>
              <img src={Logo} alt="polgozar" />
            </BrandLogo>
            <LegalLinks>
              <span>&copy; {new Date().getFullYear()} POLGOZAR. All rights reserved.</span>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </LegalLinks>
          </BottomContent>
        </Container>
      </BottomBar>
    </FooterWrapper>
  );
};

export default Footer;